import _regeneratorRuntime from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.push.js";
var __default__ = {
  name: "DashboardView",
  filters: {
    trim: function trim(value) {
      if (!value) return "";
      return value.replace(/\s+/, " ");
    }
  },
  data: function data() {
    return {
      isLoading: {
        attendance: true,
        message: true,
        enquete: true
      },
      pollingCount: 0,
      showModal: false,
      pageTitle: "",
      attendances: [],
      absentList3: [],
      absentList20: [],
      absentList30: [],
      date: "",
      currentDt: "",
      intervalId: null,
      observer: null,
      isGradeTables: true,
      attendanceDetailsTableData: [],
      todayAttendance: [],
      counterAbsentTotal: null,
      counterLunchSkipTotal: null
    };
  },
  head: {
    title: function title() {
      return {
        inner: "ダッシュボード"
      };
    },
    meta: []
  },
  computed: _objectSpread(_objectSpread({}, mapState(["school", "studentAddress", "news", "showElevatingNotice"])), {}, {
    schoolAbsentTotal: function schoolAbsentTotal() {
      if (this.isGradeTables) {
        return this.todayAttendance.filter(function (a) {
          return a.type.split("-")[0] === "欠席";
        }).length;
      }

      return this.counterAbsentTotal;
    },
    schoolLunchSkipTotal: function schoolLunchSkipTotal() {
      if (this.isGradeTables) {
        return this.todayAttendance.filter(function (a) {
          return a.type.includes("給食×");
        }).length;
      }

      return this.counterLunchSkipTotal;
    }
  }),
  watch: {
    isGradeTables: function isGradeTables(newVal) {
      // isGradeTablesの変更に応じてintervalを制御
      if (newVal) {
        // trueの場合、Index.vueのintervalを開始
        this.startInterval();
      } else {
        // falseの場合、Index.vueのintervalを停止
        this.stopInterval();
      }
    }
  },
  created: function created() {
    this.setData();
    this.currentDt = moment().format("YYYY年MM月DD日 HH時mm分");
  },
  mounted: function mounted() {
    // 初期状態でisGradeTablesがtrueの場合、intervalを開始
    if (this.isGradeTables) {
      this.startInterval();
    } // 既存のモーダル表示ロジック


    if (this.me.role_id <= 11 && !this.showElevatingNotice && this.school.elevating && this.school.elevating.date) {
      var firstDateOfMarch = moment().startOf("year").add(2, "month");
      var firstDateOfApril = moment().startOf("year").add(3, "month");

      if (moment().isAfter(firstDateOfMarch) && moment().isBefore(firstDateOfApril)) {
        var message = "生徒名簿・出席簿のダウンロードはお済みですか？" + this.school.elevating.date + "までに対応が必要です。";
        this.$store.dispatch("commitModalMessage", {
          message: message,
          title: ""
        });
        this.$store.dispatch("commitShowElevatingNotice", true);
        this.showModal = true;
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.stopInterval();
  },
  methods: {
    toggleDashboard: function toggleDashboard(showTable) {
      this.isGradeTables = showTable;
    },
    setData: function setData() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.date = moment().format("YYYY/MM/DD");
                _context.next = 3;
                return _this.getAttendance(true);

              case 3:
                _this.isLoading.attendance = false;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getAttendance: function getAttendance(calcBadge) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var a, data, attendances, today;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!calcBadge) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 3;
                return getAbsentAlert();

              case 3:
                a = _context2.sent;
                _this2.absentList3 = a.absentList3;
                _this2.absentList20 = a.absentList20;
                _this2.absentList30 = a.absentList30;

              case 7:
                _context2.next = 9;
                return getData("attendances?limit=300&with=student.classroom&from=" + moment().format("YYYY-MM-DD") + "&with_book_label=1&show_daily_all=1&orderby=updated_at&order=DESC");

              case 9:
                data = _context2.sent;
                attendances = data.items;
                _this2.attendances = attendances.sort(function (a, b) {
                  // まず updated_at で降順
                  var dateA = new Date(a.updated_at);
                  var dateB = new Date(b.updated_at);
                  if (dateA > dateB) return -1;
                  if (dateA < dateB) return 1; // 同じ updated_at の場合、id で降順

                  return b.id - a.id;
                }).map(function (a) {
                  a.absents = assignAbsentBudge(a.student, _this2.absentList3, _this2.absentList20, _this2.absentList30);
                  a.date = moment(a.date).format("YYYY年MM月DD日");
                  a.created_at = moment(a.created_at).format("MM月DD日 HH時mm分");
                  a.classroom_name = a.student && a.student.classroom ? a.student.classroom.name : null;
                  a.typeText = Text.attendances.type[a.type];
                  a.isHistory = Boolean(!a.is_daily_latest && attendances.filter(function (v) {
                    return v.student_id === a.student_id && v.to_date === a.to_date;
                  }).length > 1);
                  return a;
                }); //大規模校向けテーブルのデータを生成のため今日分のデータを抽出する

                today = moment().format("YYYY年MM月DD日");
                _this2.todayAttendance = _this2.attendances.filter(function (v) {
                  return v.date === today && v.is_daily_latest;
                });

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    startInterval: function startInterval() {
      var _this3 = this;

      if (!this.intervalId) {
        this.getAttendance(false);
        this.intervalId = setInterval(function () {
          _this3.currentDt = moment().format("YYYY年MM月DD日 HH時mm分");
          _this3.pollingCount++;

          _this3.getAttendance(_this3.pollingCount % 180 === 0);
        }, 1000 * 60 * 1);
      }
    },
    stopInterval: function stopInterval() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },
    onUpdateSummary: function onUpdateSummary(_ref) {
      var total = _ref.total,
          lunchSkip = _ref.lunchSkip;
      this.counterAbsentTotal = total;
      this.counterLunchSkipTotal = lunchSkip;
    },
    updateCurrentTime: function updateCurrentTime() {
      this.currentDt = moment().format("YYYY年MM月DD日 HH時mm分");
    },
    navigateToElevate: function navigateToElevate() {
      this.showModal = false;
      this.$router.push({
        name: "elevate"
      });
    },
    closeMessageModal: function closeMessageModal() {
      this.showModal = false;
    }
  }
};
import { ref, computed, provide } from "vue";
import moment from "moment";
import { getData } from "@/services/axios";
import Text from "@/consts/text";
import { mapState } from "vuex";
import { storeToRefs } from "pinia";
import { useSchoolPlanStore } from "@/stores/schoolPlan";
import MessageModal from "../common/MessageModal.vue";
import { getAbsentAlert, assignAbsentBudge, formatPhoneNumber } from "@/services/common";
import { useStore } from "vue2-helpers/vuex"; // モジュール読み込み

import LatestAbsenceInfo from "@/components/dashboard/LatestAbsenceInfo";
import LatestAttendanceCounter from "@/components/dashboard/LatestAttendanceCounter";
import AllClassAbsenceCounter from "@/components/dashboard/AllClassAbsenceCounter";
import GradeTable from "@/components/dashboard/GradeTable"; // import LatestTemperature from "@/components/dashboard/LatestTemperature.vue";

import LatestSchoolForum from "@/components/dashboard/LatestSchoolForum.vue";
import RowItem from "../RowItem";
import LatestGovernmentForum from "@/components/dashboard/LatestGovernmentForum.vue";
export default /*#__PURE__*/Object.assign(__default__, {
  setup: function setup(__props, _ref2) {
    var expose = _ref2.expose;
    var store = useStore();
    var me = computed(function () {
      return store.state.me;
    });
    var classrooms = computed(function () {
      return store.state.classrooms;
    });
    var phoneAttendance = computed(function () {
      return formatPhoneNumber(store.state.school.phone_attendance);
    });

    var _storeToRefs = storeToRefs(useSchoolPlanStore()),
        schoolPlan = _storeToRefs.schoolPlan;

    var attendanceMode = ref("counter");
    provide("attendanceMode", attendanceMode);
    expose({
      me: me,
      classrooms: classrooms
    });
    return {
      __sfc: true,
      store: store,
      me: me,
      classrooms: classrooms,
      phoneAttendance: phoneAttendance,
      schoolPlan: schoolPlan,
      attendanceMode: attendanceMode,
      MessageModal: MessageModal,
      LatestAbsenceInfo: LatestAbsenceInfo,
      LatestAttendanceCounter: LatestAttendanceCounter,
      AllClassAbsenceCounter: AllClassAbsenceCounter,
      GradeTable: GradeTable,
      LatestSchoolForum: LatestSchoolForum,
      RowItem: RowItem,
      LatestGovernmentForum: LatestGovernmentForum
    };
  }
});